import RpcClass from "../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.Validators';

import LocalDate from "../../../../server/LocalDate.js";
import LocalDateTime from "../../../../server/LocalDateTime.js";
import LocalTime from "../../../../server/LocalTime.js";



class Validators extends RpcClass{

    /**
     *  @class Validators
     *  @alias module:src/server/com/silkplm/rpc/Validators.Validators
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param str {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/FieldValidationResult.FieldValidationResult>}
     */
     validateBusinessEmail(str) {
            return RpcClass.rpcCall('/rpc/validators/validate-business-email', [str]);
    }
    /** 
     * @async
     * @param str {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/FieldValidationResult.FieldValidationResult>}
     */
     validateCodeColorText(str) {
            return RpcClass.rpcCall('/rpc/validators/validate-code-color-text', [str]);
    }
    /** 
     * @async
     * @param str {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/FieldValidationResult.FieldValidationResult>}
     */
     validateDomainText(str) {
            return RpcClass.rpcCall('/rpc/validators/validate-domain-text', [str]);
    }
    /** 
     * @async
     * @param str {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/FieldValidationResult.FieldValidationResult>}
     */
     validateImageFileName(str) {
            return RpcClass.rpcCall('/rpc/validators/validate-image-file-name', [str]);
    }
    /** 
     * @async
     * @param str {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/FieldValidationResult.FieldValidationResult>}
     */
     validateShortOptionalText(str) {
            return RpcClass.rpcCall('/rpc/validators/validate-short-optional-text', [str]);
    }
    /** 
     * @async
     * @param str {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/FieldValidationResult.FieldValidationResult>}
     */
     validateShortRequiredText(str) {
            return RpcClass.rpcCall('/rpc/validators/validate-short-required-text', [str]);
    }
    /** 
     * @async
     * @param str {string} 
     * @param fieldName {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/FieldValidationResult.FieldValidationResult>}
     */
     validateShortRequiredTextWithField(str, fieldName) {
            return RpcClass.rpcCall('/rpc/validators/validate-short-required-text-with-field', [str, fieldName]);
    }
    /** 
     * @async
     * @param str {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/FieldValidationResult.FieldValidationResult>}
     */
     validateShorterOptionalText(str) {
            return RpcClass.rpcCall('/rpc/validators/validate-shorter-optional-text', [str]);
    }
    /** 
     * @async
     * @param countryCode {string} 
     * @param tin {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     validateTinEU(countryCode, tin) {
            return RpcClass.rpcCall('/rpc/validators/validate-tin-e-u', [countryCode, tin]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.Validators';
metadata.__type_short__ = 'Validators';
Validators.prototype.__metadata__ = metadata;

Validators.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/Validators */
export default Validators

export { Validators }
